import NewOrders from "../features/dashboard/newOrders";

const DashboardNewOrders = () =>{
    return(
        <>
        <div className="row">
        <div className="col-1"></div>
        <div className="col-md-10 col-sm-12">
        <NewOrders />
        </div>
        <div className="col-1"></div>
      </div>
        </>
    )
};

export default DashboardNewOrders;